// frontend/src/components/nest/WeekTimeline.js
import { format } from 'date-fns';
import { Plus } from 'lucide-react';
import ActivityBlock from './ActivityBlock';

export default function WeekTimeline({ weekDates, childrenData, onAddActivity, onEditItem }) {
  return (
    <div className="grid grid-cols-7 gap-2" data-testid="week-timeline">
      {weekDates.map(date => {
        const iso = format(date, 'yyyy-MM-dd');
        return (
          <div key={iso} className="border border-sand-darker rounded-xl bg-white min-h-[220px] flex flex-col" data-testid={`week-day-${iso}`}>
            <div className="text-center py-2 border-b border-sand-darker">
              <div className="text-[10px] uppercase text-slate-400">{format(date, 'EEE')}</div>
              <div className="text-sm font-semibold">{format(date, 'd MMM')}</div>
            </div>
            <div className="p-1.5 space-y-1.5 flex-1">
              {childrenData.map(child => {
                const items = child.itemsByDate[iso] || [];
                return (
                  <div key={child.name} className="space-y-1">
                    {items.map(item => (
                      <ActivityBlock key={item.id} item={{ ...item, color: item.color || child.color }} onClick={() => onEditItem(item)} />
                    ))}
                    <button
                      onClick={() => onAddActivity(child.name, iso)}
                      className="w-full flex items-center gap-1 text-[10px] font-medium text-moana hover:bg-moana-50 hover:text-moana-dark rounded-md py-1 px-1 transition"
                      aria-label={`Add activity for ${child.name} on ${iso}`}
                      data-testid={`week-add-${child.name}-${iso}`}
                    >
                      <Plus className="w-3 h-3 flex-shrink-0" /> <span className="truncate">{child.name}</span>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
